export const RETRY_FETCH = 'merchants/RETRY_FETCH';
